import { render, staticRenderFns } from "./students-access.vue?vue&type=template&id=9ba5df4e&"
import script from "./students-access.vue?vue&type=script&lang=js&"
export * from "./students-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports